module.exports = __webpack_public_path__ + "static/quran-ayat-01-2ef9696f4fc5ca6f1b6126bdfab313c7.mp3";